const hasProp = Object.prototype.hasOwnProperty;

export default hasProp;
